<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6BKLT4/tc-custom/9780226740706.jpg?1726274072012" alt="This image is the cover for the book Mapping the Nation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mapping the Nation
      </h1>
      <p class="bookDescription body article font2">
        <b>“A compelling read” that reveals how maps became informational tools charting everything from epidemics to slavery (<i>Journal of American History</i>).</b><br/>  <br/> In the nineteenth century, Americans began to use maps in radically new ways. For the first time, medical men mapped diseases to understand and prevent epidemics, natural scientists mapped climate and rainfall to uncover weather patterns, educators mapped the past to foster national loyalty among students, and Northerners mapped slavery to assess the power of the South. After the Civil War, federal agencies embraced statistical and thematic mapping in order to profile the ethnic, racial, economic, moral, and physical attributes of a reunified nation.<br/>  <br/> By the end of the century, Congress had authorized a national archive of maps, an explicit recognition that old maps were not relics to be discarded but unique records of the nation’s past. All of these experiments involved the realization that maps were not just illustrations of data, but visual tools that were uniquely equipped to convey complex ideas and information. In <i>Mapping the Nation</i>, Susan Schulten charts how maps of epidemic disease, slavery, census statistics, the environment, and the past demonstrated the analytical potential of cartography, and in the process transformed the very meaning of a map.<br/>  <br/> Today, statistical and thematic maps are so ubiquitous that we take for granted that data will be arranged cartographically. Whether for urban planning, public health, marketing, or political strategy, maps have become everyday tools of social organization, governance, and economics. The world we inhabit—saturated with maps and graphic information—grew out of this sea change in spatial thought and representation in the nineteenth century, when Americans learned to see themselves and their nation in new dimensions.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Schulten
      </h2>
      
      <p class="authorDescription body article">Susan Schulten is professor of history at the University of Denver. In 2010 she was named a fellow of the John Simon Guggenheim Foundation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8df54eee